<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" (ngSubmit)="save()" #inspectionForm="ngForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'points.new-point' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'common.name' | translate }}</span>
        </h2>
        <div class="ir-form-group margin">
          <input name="name" class="ir-form-set" placeholder="Point name" type="text" [(ngModel)]="point.name" />
        </div>
        <h2>
          <span>{{ 'common.description' | translate }}</span>
        </h2>
        <div class="ir-form-group margin">
          <input
            name="description"
            class="ir-form-set"
            placeholder="Point description"
            type="text"
            [(ngModel)]="point.description"
          />
        </div>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
